
















































































































































































































































































































































































import { OperationsListVueGB } from "@/extensions/history/OperationsListVueGB";
import OperationBlock from "@/components/history/OperationBlock.vue";
import OperationModal from "@/components/history/OperationModal.vue";
import OperationsFilter from "@/components/history/OperationsFilter.vue";
import DatePicker from "fs-pb-vue2/components/datePicker/DatePicker.vue";
import MyChart from "@/components/app/MyChart.vue";
import SearchInput from "fs-pb-vue2/components/SearchInput.vue";
import BackLink from "@/components/app/BackLink.vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    OperationBlock,
    BackLink,
    DatePicker,
    SearchInput,
    OperationModal,
    OperationsFilter,
    MyChart
  }
})
export default class StatementList extends OperationsListVueGB {

}
